import { ErrorMessage } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

import "./InputField.styles.css";

const InputField = ({
  Labels,
  Type,
  Name,
  Classname,
  className,
  Placeholder,
  value,
  defaultValue,
  onChange,
  isInvalid,
  isValid,
  errors,
  onBlur,
  ReadOnly=false
}) => {
  // const [ Labels, Type, Name ] = props;
  return (
    <Form.Group className={Classname}>
      {Labels && <Form.Label>{Labels}</Form.Label>}
      <Form.Control
        type={Type}
        name={Name}
        readOnly={ReadOnly}
        value={value}
        onChange={onChange}
        isInvalid={isInvalid}
        placeholder={Placeholder}
        defaultValue={defaultValue}
        isValid={isValid}
        className={"input form-control input-text required-entry" + className}
      />
      <ErrorMessage
        name={Name}
        component="div"
        style={{ color: "red", marginBottom: "2px" }}
      />
      {/* <Form.Control.Feedback type="invalid">
        {errors}
      </Form.Control.Feedback> */}
    </Form.Group>
  );
};

export default InputField;
